import React from "react";
import styles from "../Services_Page/Servicespage.module.css";

const ServicesPage = () => {
  return (
    <div className={`container ${styles.servicesSection} mb-4`} id="Service_s">
      <section >
        <div className="row text-center">
          <div className="col-12">
            <h2 className={`${styles.title} mb-4`}>
              <i className={`fa-solid fa-cogs ${styles.icontitle}`}></i> Our Services
            </h2>
            <p className={styles.servicesDescription}>
              Our Management Software offers a comprehensive suite of features to help businesses across various fields operate more efficiently. From inventory management to customer tracking and billing, we’ve got you covered. Explore the features below that streamline your operations and enhance productivity, no matter your industry or business type.
            </p>
          </div>
        </div>

        <div className="row justify-content-center mt-5">
          {serviceData.map((service, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className={`${styles.serviceCard} shadow-sm`}>
                <div className={styles.iconWrapper}>
                  <i className={service.icon}></i>
                </div>
                <h3 className={styles.cardTitle}>{service.title}</h3>
                <p className={styles.cardDescription}>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

const serviceData = [
  {
    icon: "fas fa-clipboard-list",
    title: "Inventory Management",
    description: "Efficiently manage your stock levels and orders, ensuring your shop runs smoothly."
  },
  {
    icon: "fas fa-receipt",
    title: "Billing and Invoicing",
    description: "Generate accurate invoices and manage billing efficiently to save time and avoid errors."
  },
  {
    icon: "fa-solid fa-list-check",
    title: "Customer Management",
    description: "Keep track of customer data, purchase history, and engage them with personalized offers."
  },
  {
    icon: "fa-solid fa-store",
    title: "Multi-Store Management",
    description: "Monitor and control multiple store locations from a single, unified dashboard."
  },
  {
    icon: "fa-solid fa-boxes-packing",
    title: "Supplier Management",
    description: "Track supplier details, purchase orders, and maintain healthy relationships with suppliers."
  },
  {
    icon: "fa-solid fa-chart-line",
    title: "Sales Analytics",
    description: "Gain insights into sales trends, track performance, and make data-driven decisions."
  },
  {
    icon: "fa-solid fa-sliders",
    title: "Customizable Settings",
    description: "Personalize the software to meet your unique business needs and preferences."
  },
  {
    icon: "fas fa-globe",
    title: "Online Integration",
    description: "Integrate with online platforms to expand your reach and grow your business."
  }
];

export default ServicesPage;
